import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Stethoscope } from 'lucide-react';

/**
 * RoleBasedRedirect - Redirects users to appropriate dashboard based on role
 * Used as the default "/" route handler
 */
const RoleBasedRedirect = () => {
    const { user, userProfile, loading, profileLoading } = useAuth();
    const navigate = useNavigate();

    useEffect(() => {
        // Wait for auth and profile to load
        if (loading || profileLoading) return;

        // Not authenticated - redirect to login
        if (!user) {
            navigate('/login');
            return;
        }

        // Wait for profile to be available
        if (!userProfile) return;

        // Role-based dashboard mapping
        const roleDashboards = {
            admin: '/pulse-dashboard',
            doctor: '/doctor-dashboard',
            nurse: '/nursing-dashboard',
            matron: '/nursing-dashboard',
            lab_technician: '/laboratory-dashboard',
            pharmacist: '/pharmacy-dashboard',
            pharmacist_senior: '/pharmacy-dashboard',
            pharmacy_manager: '/pharmacy-dashboard',
            receptionist: '/patient-registration',
            billing_clerk: '/accounts-dashboard',
            accountant: '/accounts-dashboard',
            finance_manager: '/accounts-dashboard',
            auditor: '/accounts-dashboard',
            admin_officer: '/duty-roster',
            user: '/profile-setup'
        };

        const targetDashboard = roleDashboards[userProfile.role] || '/profile-setup';
        console.log(`🎯 [RoleBasedRedirect] Role: ${userProfile.role} → Redirecting to: ${targetDashboard}`);
        
        navigate(targetDashboard, { replace: true });
    }, [user, userProfile, loading, profileLoading, navigate]);

    // Show loading state while determining redirect
    return (
        <div className="min-h-screen flex items-center justify-center bg-gray-50">
            <div className="text-center">
                <div className="flex justify-center mb-4">
                    <div className="p-3 bg-blue-100 rounded-full">
                        <Stethoscope className="h-8 w-8 text-blue-600 animate-pulse" />
                    </div>
                </div>
                <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600 mx-auto mb-4"></div>
                <p className="text-gray-600">Loading your dashboard...</p>
            </div>
        </div>
    );
};

export default RoleBasedRedirect;
